import { POST_SALES_APARTMENT,POST_SALES_APARTMENT_CONTRACT } from "./type";

const initalState = {
  postApartData: [],
  postApartmentData: [],
};

const contractAptReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_APARTMENT:
      return {
        ...state,
        postApartData: payload,
      };
    case POST_SALES_APARTMENT_CONTRACT:
      return {
        ...state,
        postApartmentData: payload,
        postApartData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default contractAptReducer;
